import * as servicePointsServices from './servicePointsServices';

export { servicePointsServices };
